// La API v1 habla camelCase (mapping.md §S-2) mientras varios dominios ya migrados conservan
// `snake_case` en sus DTO. La conversión vive en el borde de `infrastructure/`, nunca en domain/.

type Transform = (key: string) => string;

const toSnakeKey: Transform = (key) => key.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);
const toCamelKey: Transform = (key) => key.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === Object.prototype;
}

function mapKeysDeep(value: unknown, transform: Transform): unknown {
  if (Array.isArray(value)) return value.map((item) => mapKeysDeep(item, transform));
  if (!isPlainObject(value)) return value;
  return Object.fromEntries(
    Object.entries(value).map(([key, inner]) => [transform(key), mapKeysDeep(inner, transform)])
  );
}

/** Respuesta v1 (camelCase) → forma `snake_case` que esperan los DTO zod ya escritos. */
export const toSnakeCaseKeys = (value: unknown): unknown => mapKeysDeep(value, toSnakeKey);

/** Payload `snake_case` del dominio → cuerpo camelCase que exige v1. */
export const toCamelCaseKeys = (value: unknown): unknown => mapKeysDeep(value, toCamelKey);

/**
 * Desenvuelve una colección: v1 pagina unos recursos (`{ items, total, ... }`) y devuelve array
 * plano en otros (mapping.md §A-10). Acepta ambas formas para un mismo parser.
 */
export function toItemArray(value: unknown): unknown[] {
  if (Array.isArray(value)) return value;
  if (isPlainObject(value) && Array.isArray(value.items)) return value.items;
  return [];
}
